import { Outlet, createFileRoute } from '@tanstack/react-router'
import { fetchMarketingThreads } from '@/api/agents/marketingAgent'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/marketing-agent')({
  loader: async ({ params }) => {
    const projectId = parseInt(params.projectId, 10)
    const { threads } = await fetchMarketingThreads(projectId)
    return { threads }
  },
  component: MarketingAgentLayout
})

function MarketingAgentLayout() {
  return (
    <div className="flex h-full flex-col">
      <Outlet />
    </div>
  )
}
